module.exports = __webpack_public_path__ + "img/home_banner.1aae5014.jpg";